/**
 * The router's real numbers.
 *
 * These are not illustrative. They are `DefaultWeights()` and
 * `DefaultPenalties()` from `internal/routing/weights.go`, and
 * `routing.test.ts` reads that file and fails if these drift from it.
 *
 * The test exists because the numbers were nearly wrong on the first draft:
 * `docs/ROUTING.md` documents nine components including a `reviewer_diversity`
 * that the code does not have, and gives `capability_match` as 0.24 where the
 * shipped table says 0.20. A landing page printing the documented figures would
 * have been printing figures the product does not use. Docs drift; the code is
 * the source.
 */

export interface Component {
  /** The key the engine uses, printed as-is because it is a machine value. */
  key: string
  weight: number
}

export interface Penalty {
  key: string
  weight: number
}

/** internal/routing/weights.go — DefaultWeights() */
export const COMPONENTS: readonly Component[] = [
  { key: 'verified_model', weight: 0.25 },
  { key: 'provider_capacity', weight: 0.25 },
  { key: 'capability_match', weight: 0.2 },
  { key: 'session_continuity', weight: 0.15 },
  { key: 'host_repository_locality', weight: 0.1 },
  { key: 'user_preference', weight: 0.05 },
] as const

/** internal/routing/weights.go — DefaultPenalties() */
export const PENALTIES: readonly Penalty[] = [
  { key: 'rate_limit_proximity', weight: 0.12 },
  { key: 'unknown_capacity', weight: 0.08 },
  { key: 'stale_auth', weight: 0.05 },
  { key: 'model_lifecycle', weight: 0.05 },
] as const
